import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import SafeDigitalWatersLogo from "../assets/SafeDigitalWatersLogo.png";
import { Box, Flex, Heading, Image, useColorModeValue } from "@chakra-ui/react";
import MenuButton from "./MenuButton";
import { Categories } from "../assets/categories";
import { FaChevronCircleLeft } from "react-icons/fa";
import { motion } from "framer-motion";
import Photo1 from "../assets/justredi-ggek-mindev.png";
import Photo2 from "../assets/greece-2-next-generation.png";

function RouteDictionary(route: string) {
    if (route === "/") return "Αρχική";
    else {
        for (let i = 0; i < Categories.length; i++) {
            if (Categories[i].route === route) return Categories[i].title;
        }
    }
}

export default function Header() {
    const navigate = useNavigate();
    const loc = useLocation();
    const [currentName, setCurrentName] = useState(RouteDictionary(loc.pathname));
    useEffect(() => {
        setCurrentName("")
        setTimeout(() => {
            setCurrentName(RouteDictionary(`${loc.pathname}`));
        }, 100)
    }, [loc]);

    const goToHomePage = () => {
        navigate("/");
    };

    const headerColor = useColorModeValue("primary", "light");
    const backButtonColor = useColorModeValue("primary", "primary");

    return (
        <>
            <Flex
                bgColor={useColorModeValue("light", "darkprimary")}
                position={{ sm: "relative", lg: "sticky" }}
                direction="row"
                w="100%"
                alignItems="center"
                zIndex={99}
                justifyContent="space-between"
                padding="1rem"
                top="0">
                {/* Αριστερά: Logo + Αρχική */}
                <Flex
                    w={"fit-content"}
                    direction={"row"}
                    alignItems="center"
                    justifyContent="space-between"
                    gap={4}>
                    <Flex
                        alignItems="center"
                        justifyContent="space-between"
                        w={{ sm: "100%", lg: "fit-content" }}
                    >
                        <Image
                            src={SafeDigitalWatersLogo}
                            onClick={goToHomePage}
                            cursor="pointer"
                            w={{ sm: "80px", xl: "100px" }}
                        />
                        <Box
                            display={{ sm: "block", lg: "none" }}
                            marginLeft={{ sm: `${loc.pathname !== "/" ? "10px" : "0px"}` }}
                        >
                            {loc.pathname !== "/" ? (
                                <Box
                                    cursor="pointer"
                                    onClick={goToHomePage}
                                    w={{ sm: "20px", lg: "20px", xl: "24px" }}
                                >
                                    <svg
                                        className="back-btn-svg"
                                        width="100%"
                                        viewBox="0 0 11 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1 5.66666H10.0575"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M5.52881 0.999985L10.0575 5.66665L5.52881 10.3333"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Box>
                            ) : null}
                        </Box>
                    </Flex>
                    <Flex
                        alignItems="center"
                        justifyContent="center"
                        color={headerColor}
                        gap={3}
                    >
                        {loc.pathname !== "/" ? (
                            <motion.span
                                onClick={goToHomePage}
                                initial={{ opacity: 0, y: -200 }}
                                animate={{ opacity: 1, y: 0 }}
                                style={{ backgroundColor: backButtonColor, cursor: "pointer" }}
                                transition={{ duration: 0.2, delay: 0.25 }}
                            >
                                <FaChevronCircleLeft size="2rem" />
                            </motion.span>
                        ) : null}

                        <Heading fontSize={{ sm: 32, lg: 34 }} fontWeight={500}>
                            {currentName ? currentName.split("").map((el, i) => (
                                <motion.span
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.1, delay: i / 40 }}
                                    key={i}
                                >
                                    {el}{""}
                                </motion.span>
                            )) : null}
                        </Heading>
                    </Flex>
                </Flex>

                {/* Δεξιά: Δύο εικόνες + MenuButton */}
                <Flex display={{lg: "flex" }} alignItems="center" gap={3}>
                    <Image
                        src={Photo1}
                        alt="Photo 1"
                        h={{ base: "28px", sm: "32px", md: "60px", lg: "80px" }}
                    />
                    <Image
                        src={Photo2}
                        alt="Photo 2"
                        h={{ base: "28px", sm: "32px", md: "60px", lg: "80px" }}
                    />
                    <Box display={{ base: "none", lg: "block" }}>
                        <MenuButton />
                    </Box>
                </Flex>
            </Flex>
            <Flex
                w="100%"
                paddingX="20px"
                zIndex={99}
                height="60px"
                alignItems="center"
                justifyContent="space-around"
                backgroundColor={useColorModeValue("lightBlue", "primary")}
                display={{ sm: "flex", lg: "none" }}
                position="fixed"
                bottom="0"
            >
                <Box onClick={goToHomePage}>
                    <svg
                        className="home-svg"
                        width="28"
                        height="30.8"
                        viewBox="0 0 20 22"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1 8L10 1L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8Z"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            stroke={useColorModeValue("#094169", "#eee")}
                        />
                        <path
                            d="M7 21V11H13V21"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            stroke={useColorModeValue("#094169", "#eee")}
                        />
                    </svg>
                </Box>
                <MenuButton />
            </Flex>
            <Outlet />
        </>
    );
}
